import { isAfter, isBefore, isEqual, parse, sub } from "date-fns";
import type { Question, RegistrationQuestion, IconOption } from "./types";

const months = new Array(12).fill(0).map((_, i) => {
    const date = new Date("2024-01-01");
    date.setMonth(date.getMonth() + i);
    return date.toLocaleString('default', { month: 'long' });
});

export const appConfig = {
    answerMaxLength: 600
}

export const part1: { title: string, questions: Question[] } = {
    "title": "Dokończ przysłowie i kliknij w poprawną odpowiedź:",
    "questions": [
        {
            "id": 1,
            "question": "Co nagle, to…",
            "answers": [
                {
                    "id": "A",
                    "answer": "niebezpieczne",
                    "correct": false
                },
                {
                    "id": "B",
                    "answer": "po diable",
                    "correct": true
                },
                {
                    "id": "C",
                    "answer": "najlepsze",
                    "correct": false
                },
                {
                    "id": "D",
                    "answer": "za szybko",
                    "correct": false
                }
            ]
        },
        {
            id: 2,
            question: "Lepszy wróbel w garści…",
            answers: [
                {
                    id: "A",
                    answer: "niż kanarek w klatce",
                    correct: false
                },
                {
                    id: "B",
                    answer: "niż gołąb na dachu",
                    correct: true
                },
                {
                    id: "C",
                    answer: "niż kura w koszu",
                    correct: false
                },
                {
                    id: "D",
                    answer: "niż ryba w wodzie",
                    correct: false
                }
            ]
        },
        {
            id: 3,
            question: "Jak sobie pościelesz…",
            answers: [
                {
                    id: "A",
                    answer: "tak się wyśpisz",
                    correct: true
                },
                {
                    id: "B",
                    answer: "tak ci dadzą",
                    correct: false
                },
                {
                    id: "C",
                    answer: "tak ci będzie",
                    correct: false
                },
                {
                    id: "D",
                    answer: "tak ci los da",
                    correct: false
                }
            ]
        },
        {
            id: 4,
            question: "Gdzie kucharek sześć…",
            answers: [
                {
                    id: "A",
                    answer: "tam chaos",
                    correct: false
                },
                {
                    id: "B",
                    answer: "tam tłok",
                    correct: false
                },
                {
                    id: "C",
                    answer: "tam nie ma co jeść",
                    correct: true
                },
                {
                    id: "D",
                    answer: "tam brak siódmej",
                    correct: false
                }
            ]
        },
        {
            id: 5,
            question: "Wilk syty i…",
            answers: [
                {
                    id: "A",
                    answer: "owca cała",
                    correct: true
                },
                {
                    id: "B",
                    answer: "pies spokojny",
                    correct: false
                },
                {
                    id: "C",
                    answer: "koza szczęśliwa",
                    correct: false
                },
                {
                    id: "D",
                    answer: "gospodarz zadowolony",
                    correct: false
                }
            ]
        },
        {
            id: 6,
            question: "Ziarnko do ziarnka…",
            answers: [
                {
                    id: "A",
                    answer: "i będzie koszyk pełny",
                    correct: false
                },
                {
                    id: "B",
                    answer: "i będzie chleb",
                    correct: false
                },
                {
                    id: "C",
                    answer: "a zbierze się miarka",
                    correct: true
                },
                {
                    id: "D",
                    answer: "a powstanie sterta",
                    correct: false
                }
            ]
        }
    ]
}

export const coRegistrationQuestions: RegistrationQuestion[] = [
  
  {
    type: "radio",
    question: "Umawiamy jazdy testowe topowych marek, która z nich trafia w Twój gust?",
    prop: "prop49",
    filter: (consents) => true,
    options: ["Hyundai", "Nissan", "Mitsubishi", "BMW", "Toyota", "Mazda", "Ford", "VW", "Renault", "inna", "samochód elektryczny", "marki chińskie", "nie jestem zainteresowany/a"], 
},
    {
        type: "radio",
        question: "Nasz konsultant zadzwoni do Ciebie w celu przekazania dalszych szczegółów - czy potwierdzasz chęć zapisu?",
        prop: "prop56",
        filter: (consents, user, answers) => {
           return typeof answers?.prop49 === 'string' && answers.prop49.toLowerCase() !== "nie jestem zainteresowany/a";
        },
        options: ["tak", "nie"],
    },
    {
    type: "radio",
    question: "Szukasz rozrywki bez ograniczeń? 🎬 Odkryj pakiety nowoczesnej TV od Play 📺",
    prop: "prop77",
    filter: (consents) => false,
    options: ["odkryj teraz", "nie, dziękuję"] 
},
    {
    type: "radio",
    question: "Czy wiesz, że możesz dostać gotówkę za samochód i nadal nim jeździć bez żadnych ograniczeń?",
    filter: (consents) => true,
    class: "in-row1",
    prop: "prop95",
    options: [
      "chętnie sprawdzę ile gotówki mogę otrzymać za moje auto",
      "nie interesuje mnie ten temat"
    ]
  },
    {
    type: "radio",
    question: "Czy Twoje auto ma mniej niż 15 lat?",
    prop: "prop96",
    filter: (consents, user, answers) => answers?.prop95 === "chętnie sprawdzę ile gotówki mogę otrzymać za moje auto",
    class: "in-row1",
    options: [
      "tak",
      "nie",
      "nie pamiętam"
    ]
  },
    {
    type: "radio",
    question: "Czy Twój samochód ma przebieg poniżej 300 tysięcy kilometrów?",
    prop: "prop97",
    filter: (consents, user, answers) => answers?.prop96 === "tak" || answers?.prop96 === "nie pamiętam",
    class: "in-row1",
    options: [
      "tak",
      "nie",
      "nie wiem"
    ]
  },
    {
        type: "select",
        question: 'Kiedy kończy Ci się umowa z operatorem GSM?',
        prop: 'prop66',
        filter: (consensts, user, data) => false, //['prop22', 'prop26', 'prop27'].every(c => consensts.includes(c)),
        //options: [...months, 'mam telefon na kartę', 'mam umowę na czas nieokreślony', 'nie pamiętam'],
        //inisTrack: 'cpl_coreg_2_GSM'
    },
    {
        type: "radio",
        question: 'Lekarze bez Granic to niezależna medyczna organizacja humanitarna niosąca pomoc przy konfliktach zbrojnych, epidemiach, katastrofach naturalnych.<br>Które działania Lekarzy bez Granic chcesz wesprzeć?:',
        prop: 'prop70',
        filter: (c, user, data) => true,
        class: 'in-row-images-3',
        options: [{
            label: "leczenie niedożywienia",
            img: "/img/image39.jpg"
        }, {
            label: "dostęp do opieki okołoporodowej",
            img: '/img/image31.jpg'
        }, {
            label: "pomoc pokrzywdzonym w konfliktach zbrojnych",
            img: '/img/image8.jpg'
        }, {
            label: "pomoc pokrzywdzonym na skutek katastrof naturalnych",
            img: '/img/image16.jpg',
        }, {
            label: "walka z chorobami zakaźnymi np. gruźlicą",
            img: '/img/image6.jpg',
        },
        {
            label: "nie jestem zainteresowana/y",
            img: '/img/image36.jpg',
        }],
        inisTrack: 'cpl_coreg_4_LBG'
    },
    {
        type: "radio",
        question: 'UNICEF od 79 lat ratuje życie dzieciom w ponad 190 krajach.<br>Które z działań UNICEF chce Pani/Pan wesprzeć?',
        prop: 'prop92',
        filter: (c, user, data) => false,
        class: 'in-row-images-3',
        options: [{
            label: "walka z niedożywieniem",
            img: "/img/image46.jpg"
        }, {
            label: "dostarczanie czystej wody",
            img: '/img/image47.jpg'
        }, {
            label: "dostęp do opieki medycznej",
            img: '/img/image48.jpg'
        }, {
            label: "wsparcie psychologiczne",
            img: '/img/image49.jpg',
        }, {
            label: "dostęp do edukacji",
            img: '/img/image50.jpg',
        },
        {
            label: "nie jestem zainteresowana/y",
            img: '/img/image51.jpg',
        }],
        inisTrack: 'cpl_coreg_unicef'
    },
    {
        type: "radio",
        question: "Fundacja Dr Clown od 26 lat niesie pomoc dzieciom w 170 szpitalach i placówkach specjalnych w Polsce. Który z obszarów chcesz wesprzeć?",
        prop: "prop89",
        filter: (consents, user) => false,
        class: "in-row-images-3",
        options: [{
            label: "terapia śmiechem i zabawą dla dzieci",
            img: "/img/image40.jpg"
        }, {
            label: "mobilny gabinet Dr Clowna (oswajanie dzieci ze szpitalem)",
            img: "/img/image41.jpg"
        }, {
            label: "dogoterapia (terapia przez zajęcia z psami)",
            img: "/img/image42.jpg"
        }, {
            label: "wsparcie dla seniorów i dorosłych",
            img: "/img/image43.jpg"
        }, {
            label: "tworzenie kącików zabaw",
            img: "/img/image44.jpg"
        }, {
            label: "nie jestem zainteresowana/y",
            img: "/img/image45.jpg"
        }],
    },
     {
    type: "radio",
    question: "Szukasz oszczędności? Która z aktualnych okazji interesuje Cię najbardziej?",
    prop: "prop81",
    class: "grid-cols-1",
    filter: () => true,
    options: [
            {
        value: 'chcę abonament za 0 zł przez 5 miesięcy od Orange',
        label: 'chcę abonament za 0 zł przez 5 miesięcy od <span style="color:#FF7900"> Orange</span>',
      },
      {
        value: 'chcę smartfona 400 zł taniej od T-Mobile',
        label: 'chcę smartfona 400 zł taniej od <span style="color:#E20074"> T-Mobile</span>',
      },
	{
        value: 'chcę płacić mniej za abonament',
        label: 'chcę płacić mniej za abonament',
      },
      { value: 'dziękuję, nie chcę oszczędzać', label: 'dziękuję, nie chcę oszczędzać' },
    ],
  },
    {
        type: "radio",
        question: 'Chcesz bezpłatnie sprawdzić swój poziom angielskiego i poznać ofertę Tutlo? 🗽🌍💂',
        prop: 'prop39',
        filter: (consents, user, data) => false,
        options: ['tak, chcę sprawdzić swój angielski', 'chcę otrzymać informację o aktualnych promocjach', 'nie jestem zainteresowany'],
        inisTrack: 'cpl_profilowe_5_jezyk'
    },
        {
    type: "radio",
    question: "Czy posiadasz lub spłacałeś/aś w przeszłości jeden z poniższych kredytów?",
    prop: "prop40",
    filter: (consents) => true,
    options: ["tak, we frankach szwajcarskich", "tak, w euro", "tak, kredyt hipoteczny w złotówkach", "tak, pożyczkę / kredyt gotówkowy w złotówkach", "nie posiadam takich kredytów"],
  },
	{
        type: "radio",
        question: 'Co daje Ci największe poczucie spokoju o przyszłość swoją i Twoich bliskich?',
        prop: 'prop72',
        filter: (consents, user, data) => true,
        options: ['aktywna polisa na życie, którą już posiadam', 'dopiero szukam dobrego zabezpieczenia', 'chcę dowiedzieć się, ile kosztuje taka ochrona', 'nie zastanawiam się nad tym teraz'],
        inisTrack: 'cpl_polsatbox'
    },
    {
    type: "radio",
    question: "📱Chcesz płacić mniej za abonament z nowym smartfonem w pakiecie?",
    prop: "prop80",
    filter: (consents) => false,
    options: ["tak, proszę o kontakt eksperta", "nie, nie szukam oszczędności"],
  },
        {
        type: "radio",
        question: 'Szybki Internet za mniej niż 40 zł/mies. z gwarancją ceny na 2 lata - brzmi dobrze?',
        prop: 'prop82',
        filter: (consents, user, data) => true,
        options: ['tak, proszę o kontakt eksperta', 'nie, mój Internet jest ok'],
        inisTrack: 'cpl_orange_swiatlowod'
    },
    {
    type: "promo",
    question: `<p class="font-bold text-lg mb-2">Potrzebna dodatkowa gotówka?</p>
<p class="mb-1">Możesz dostać od 12&nbsp;000 zł do 300&nbsp;000 zł.</p>
<p>RRSO 14,89%</p>`,
    prop: "prop84",
    filter: () => true,
    class: "grid-cols-1",
    image: {
      src: "pko.png",
      class: "w-full h-auto",
    },
    options: [
      "tak, chcę dowiedzieć się więcej",
      "nie, nie potrzebuję dodatkowych pieniędzy",
    ],
    legal: {
      preview: "Rzeczywista Roczna Stopa Oprocentowania (RRSO) wynosi 14,89%. Całkowita kwota kredytu (bez kredytowanych kosztów) 26 200,00 zł. Całkowita kwota do zapłaty: 37 302,59 zł. Oprocentowanie zmienne: 13,95%. Całkowity koszt kredytu: 11 102,59 zł (w tym: prowizja: 0,00 zł, odsetki: 11 102,59 zł). 63 miesięcznych rat równych po 579,94 zł i ostatnia rata: 766,45 zł. Kalkulację przeprowadziliśmy 18.11.2025 r. na reprezentatywnym przykładzie.",
      more: "Udzielenie pożyczki jest uzależnione od posiadania zdolności kredytowej.\n\nWyliczenia mają charakter orientacyjny i przykładowy. Zależą od daty wypłaty kredytu oraz daty płatności pierwszej raty. Służą wyłącznie celom informacyjnym i nie powinny być traktowane jako oferta, rekomendacja, zaproszenie do zawarcia umowy kredytu ani usługa doradztwa. Te informacje powinny być analizowane razem z formularzem informacyjnym banku przed zawarciem umowy o kredyt konsumencki.\n\nSzczegółowe informacje o pożyczce, w tym Taryfa prowizji i opłat bankowych, są dostępne w placówkach Banku i na www.pkobp.pl.",
    },
  },
    {
        type: "radio",
        question: "Czy kiedykolwiek brałeś/aś chwilówkę lub pożyczkę w banku?",
        prop: "prop40",
        filter: (consents, user, data) => false,
        options: ["tak, kredyt gotówkowy w banku", "tak, pożyczkę chwilówkę", "nie, ale rozważam to", "nie i nie zamierzam brać pożyczek"],
        inisTrack: "cpl_profilowe_6_kredyt",
      },
     {
    type: "radio", 
    question: "Kiedy kończy Ci się ubezpieczenie OC samochodu?",
    prop: "prop65",
    filter: (consents) => ["prop22", "prop26", "prop27"].every((c) => consents.includes(c)),
    class: "in-row2", 
    options: [
      "styczeń", "luty", "marzec", 
      "kwiecień", "maj", "czerwiec", 
      "lipiec", "sierpień", "wrzesień", 
      "październik", "listopad", "grudzień", "nie mam auta", "nie wiem"],
    inisTrack: "cpl_coreg_1_OC",
  },
    {
        type: "radio",
        question: 'Jakie jest źródło Twojego dochodu?',
        prop: 'prop68',
        filter: (consensts, user, data) => false // ['prop22', 'prop26', 'prop27'].every(c => consensts.includes(c)) /* && user.gender === 'mezczyzna' */,
        //options: ['umowa o pracę', 'umowa zlecenie/dzieło', 'emerytura/renta', 'zasiłek', 'własna działalność', 'inne', 'brak dochodu'],
        //inisTrack: 'cpl_coreg_3_B2B'
    },
    {
        type: "radio",
        question: "Na ile oceniasz swoją niezależność od podwyżek cen prądu?",
        prop: "prop74",
        filter: (consents, user, data) => false,
        inisTrack: "cpl_coreg_9_fotowoltaika",
        class: 'grid-cols-1',
        options: ["niska – płacę standardowe rachunki", "średnia – mam panele, ale bez magazynu (oddaję prąd do sieci)", "wysoka – mam panele i magazyn energii"],
      },
    {
        type: "radio",
        question: "Chcesz, żeby Twoja fotowoltaika znów zarabiała?",
        prop: "prop78",
        filter: (consents, user, data) => data.prop74 === "mam już fotowoltaikę",
        options: ["chcę dowiedzieć się więcej o magazynie energii", "nie, nie chcę"]
      },
    {
        type: "radio",
        question: 'Czy masz dzieci?',
        prop: 'prop35',
        filter: (consents, user, data) => false,
        options: ['tak', 'nie'],
        inisTrack: 'cpl_profilowe_13_dzieci'
    },
    {
        type: "radio",
        question: "Czy chcesz przetestować nowoczesne aparaty słuchowe za darmo?",
        prop: "prop67",
        filter: (consents, user, data) => false, /* {
            const today = new Date();
            const maxDate = sub(today, { years: 60 });
            const date = parse(user.dob as string, "dd-MM-yyyy", new Date());

            return (
                ["prop22", "prop26", "prop27"].every(c => consents.includes(c)) &&
                date.toString() !== "Invalid Date" &&
                (isBefore(date, maxDate) || isEqual(date, maxDate))
            );
        }, */
        options: ["tak, chętnie", "nie jestem zainteresowany/a"],
        inisTrack: "cpl_coreg_3_aparaty"
    },
    {
    type: "radio",
    question: "Szukasz oszczędności? Która z aktualnych okazji telekomunikacyjnych interesuje Cię najbardziej?",
    prop: "prop81",
    class: "grid-cols-1",
    filter: (consents) => false,
    options: [
        {
            value: 'chcę nowoczesną TV od Play!',
            label: '📺 chcę nowoczesną TV od <span style="color:#6C43BF">Play</span>!',
        },
        {
            value: 'szukam smartfona z abonamentem już od 59 zł/mies od Orange',
            label: 'szukam smartfona📱z abonamentem już od 59 zł/mies od <span style="color:#FF7900">Orange</span>',
        },
        {
            value: 'poproszę niski abonament Nju Mobile - 3 miesiące za 0 zł',
            label: '💵 poproszę niski abonament <span style="color:#00B1CC">Nju Mobile</span> - 3 miesiące za 0 zł',
        },
        { value: 'dziękuję, nie chcę oszczędzać', label: 'dziękuję, nie chcę oszczędzać' },
    ],
  },
    {
      type: "radio",
      question: "Czy w ciągu ostatnich 12 miesięcy zalało Ci mieszkanie?",
      prop: "prop72",
      filter: (consents, user, data) => false
        /* ["prop22", "prop26", "prop27"].every(c => consents.includes(c)) */,
      options: ["tak", "nie"],
    },
    
    {
        type: 'component',
        component: () => import('~/components/Loando.vue'),
        filter: (consents, user, data) => false,
        options: [],
    },
    
    {
        type: "radio",
        question: `Co by Cię przekonało do zakupu pakietu medycznego?`,
        prop: 'prop71',
        inisTrack: 'cpl_coreg_7_+pakiet_medyczny+',
        filter: (consensts, user, data) => ['prop22', 'prop26', 'prop27'].every(c => {
            return false;
            const today = new Date();
            const maxDate = sub(today, { years: 60 });
            const date = parse(user.dob as string, 'dd-MM-yyyy', 12);
            return consensts.includes(c) /* && date.toString() !== 'Invalid Date' && (isBefore(date, maxDate) || isEqual(date, maxDate)) */;
        }),
        options: ['najniższa rynkowa cena', 'brak kolejek', 'pakiet zawierający teleporady oraz wizyty stacjonarne', 'nic by mnie nie przekonało'],
    },
    {
        type: "radio",
        question: 'Czy chcesz nauczyć się inwestować?',
        prop: 'prop69',
        filter: (consensts, user, data) => false, // ['prop22', 'prop26', 'prop27'].every(c => consensts.includes(c)),
        options: ["tak, chcę porozmawiać ze specjalistą", "nie interesuje mnie ten temat"],
        inisTrack: 'cpl_coreg_5_inwestycje'
    },
    {
        type: "radio",
        question: 'Czy chcesz pobrać aplikację ułatwiającą codzienne zarabianie na małe przyjemności?',
        prop: 'prop76',
        filter: (consensts, user, data) => false, // ['prop22', 'prop26', 'prop27'].every(c => consensts.includes(c)),
        options: ["TAK - chcę spróbować i zarobić", "NIE - rezygnuję z korzyści"],
        onAnswer: async (answer) => {
            if (answer === "TAK - chcę spróbować i zarobić") {
                window.open('https://app.polecamprodukt.pl/?utm_medium=konkurs&utm_source=quiztopieniadz&utm_campaign=salelifter', '_blank', 'noopener');
            }
        },
        image: {
            src: 'image17.png',
            class: 'w-48 h-auto'
        }
    },
    {
        type: "radio",
        question: "Czy wiesz, że już od 1,30 zł dziennie możesz zabezpieczyć swoją przyszłość?",
        prop: "prop83",
        filter: () => false,
        options: ["brzmi świetnie - poproszę o więcej informacji", "nie interesuje mnie to"],
        inisTrack: "cpl_ubezpieczenie",
    },
    {
        type: "radio",
        question: "Twój internet w telefonie ciągle się kończy? 🚀 Zgłoś się po nielimitowane pakiety i superoferty w Play!",
        prop: "prop88",
        filter: (consents) => false,
        options: ["tak, poproszę o szczegóły", "nie, dziękuję"],
    },

]

export const profileQuestions: RegistrationQuestion[] = [
    {
        type: "radio",
        question: 'Czy masz ogród?',
        prop: 'prop36',
        filter: (consents, user, data) => false,
        options: ['tak', 'nie'],
        inisTrack: 'cpl_profilowe_2_dom'
    },
    {
        type: "radio",
        question: 'Na co dzień poruszasz się:',
        prop: 'prop37',
        filter: (consents, user, data) => false,
        class: 'in-row-images',
        inisTrack: 'cpl_profilowe_3_komunikacja',
        options: [{
            label: "samochodem",
            img: "/img/autem.jpeg"
        }, {
            label: "komunikacją miejską",
            img: '/img/komunikacja.jpeg'
        }, {
            label: "rowerem",
            img: '/img/rowerem.jpeg'
        }, {
            label: "pieszo",
            img: '/img/pieszo.jpeg',

        }, {
            label: "inne",
            img: '/img/inaczej.jpeg',
            class: 'md:col-span-2'
        },
        {
            label: "siedzę w domu",
            img: '/img/wdomu.jpeg',
            class: 'md:col-span-2'
        }]
    },
    {
        type: "radio",
        question: 'Jakie masz wykształcenie?',
        inisTrack: 'cpl_profilowe_4_wyksztalcenie',
        prop: 'prop38',
        class: 'in-row2',
        filter: (consensts, user, data) => ['prop26', 'prop27'].every(c => !consensts.includes(c)),
        options: ["podstawowe", "gimnazjalne", "zasadnicze", "średnie", "wyższe"]
    },
    /*     {
            type: "radio",
            question: 'Czy kiedykolwiek brałeś/aś pożyczkę gotówkową lub kredyt konsumpcyjny?',
            prop: 'prop40',
            filter: (consensts, user, data) => ['prop26', 'prop27'].every(c => !consensts.includes(c)),
            options: ["tak", "nie"],
            inisTrack: 'cpl_profilowe_6_kredyt'
        } */
]

export const partners = [
    {
        id: 1,
        name: "Energia",
        label: "Energia (dostawcy energii, paliw, gazu itp.)",
        enabled: true
    },
    {
        id: 2,
        name: "Finanse",
        label: "Finanse (pożyczki, karty kredytowe, kredyty, inwestycje, odszkodowania itp.)",
        enabled: true
    },
    {
        id: 3,
        name: "Handel detaliczny",
        label: "Handel detaliczny (sprzedaż online, stacjonarna, FMCG, motoryzacja, beauty itp.)",
        enabled: true
    },
    {
        id: 4,
        name: "Lifestyle",
        label: "Lifestyle (zdrowie i uroda, fitness itp.)",
        enabled: true
    },
    {
        id: 5,
        name: "Media i wydawnictwa",
        label: "Media i wydawnictwa (hobby, gry, edukacja, social media itp.)",
        enabled: true
    },
    {
        id: 6,
        name: "Telekomunikacja",
        label: "Telekomunikacja (usługi telefoniczne i internetowe itp.)",
        enabled: true
    },
    {
        id: 7,
        name: "Turystyka",
        label: "Turystyka (podróże, noclegi, biura podróży itp.)",
        enabled: true
    },
    {
        id: 8,
        name: "Ubezpieczenia",
        label: "Ubezpieczenia (osobowe, turystyczne, majątkowe itp.)",
        enabled: true
    },
    {
        id: 9,
        name: "INIS Sp. z o.o.",
        label: "INIS Sp. z o.o., z siedzibą w Rybniku (44‑200), ul. Raciborska 35a",
        enabled: true
    },
    {
        id: 10,
        name: "Caf Call Sp. z o.o.",
        label: "Caf Call Sp. z o.o. ul. rondo Marsz. Józefa Piłsudskiego 28, 05-120 Legionowo",
        enabled: true
    },
    {
        id: 11,
        name: "Fundacja Lekarze bez Granic",
        label: "Fundacja 'Lekarze bez Granic' ul. Sapieżyńska 10A, 00-215 Warszawa",
        enabled: true
    },
    {
        id: 12,
        name: "Colonnade Insurance Societe Anonyme",
        label: "Colonnade Insurance Societe Anonyme SA Oddział w Polsce, ul. Prosta 67, 00-838 Warszawa",
        enabled: true
    },
    {
        id: 13,
        name: "Call Center House Sp. z o.o.",
        label: "Call Center House Sp. z o.o. Aleja T. Kościuszki 80/82, 90-437 Łódź",
        enabled: true
    },
    {
        id: 14,
        name: "Sanmarks Sp. z o.o.",
        label: "Sanmarks Sp. z o.o. ul. Słowackiego 36, Lubaczów",
        enabled: true
    },
 {
        id: 15,
        name: "CC POINT Sp. z o.o.",
        label: "CC POINT Sp. z o.o. ul. Aleja T. Kościuszki nr 80/82, 90-437 Łódź",
        enabled: true
    },
	 {
        id: 16,
        name: "Prooperate sp. z o.o.",
        label: "Prooperate sp. z o.o., ul. Poloneza 93, 02-826 Warszawa",
        enabled: true
    },
 {
        id: 17,
        name: "Alpha Sp. z o.o.",
        label: "Alpha Sp. z o.o.,ul. Juliusza Słowackiego 24/67, 35-060 Rzeszów",
        enabled: true
    },
 {
        id: 18,
        name: "Franki Kancelaria Sp. z o.o.",
        label: "Franki Kancelaria Sp. z o.o., ul. Izaaka 7, 31-057 Kraków",
        enabled: true
    },
 {
        id: 19,
        name: "Sławomir Glinkau",
        label: "Sławomir Glinkau, ul, Ptasia 5/19, 93-571 - w celu prezentacji oferty Phinance S.A.",
        enabled: true
    }
];
